module.exports = __webpack_public_path__ + "img/about.1615786b.webp";